// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-notification-option {
  margin-bottom: 1.5rem;
  padding: 16px;
  border: 1px solid rgba(74, 108, 247, 0.2);
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.main-notification-content {
  flex: 1 1;
}

.main-notification-option .settings-option-label {
  color: #4a6cf7;
  font-size: 1.1rem;
  font-weight: 600;
}

.main-notification-option .settings-option-description {
  margin-top: 8px;
  padding: 8px 12px;
  background-color: rgba(74, 108, 247, 0.1);
  border-radius: 4px;
  color: #4a6cf7;
}
`, "",{"version":3,"sources":["webpack://./src/styles/notification-settings.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,aAAa;EACb,yCAAyC;EACzC,kBAAkB;EAClB,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":[".main-notification-option {\n  margin-bottom: 1.5rem;\n  padding: 16px;\n  border: 1px solid rgba(74, 108, 247, 0.2);\n  border-radius: 8px;\n  background-color: #fff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.main-notification-content {\n  flex: 1;\n}\n\n.main-notification-option .settings-option-label {\n  color: #4a6cf7;\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.main-notification-option .settings-option-description {\n  margin-top: 8px;\n  padding: 8px 12px;\n  background-color: rgba(74, 108, 247, 0.1);\n  border-radius: 4px;\n  color: #4a6cf7;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
